<!-- 学院新闻 -->
<template>
  <div class="schoolnew">
    <div class="header">
      <my-header></my-header>
    </div>
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div class="swiper">
      <my-swiper></my-swiper>
    </div>
    <div class="hostnew">
      <my-hostnew></my-hostnew>
    </div>
    <div class="article" style="height: 50px;">
      <my-article newsTitle="友情链接" newsType="" style="height: 430px;color:rgb(80, 150, 255);font-weight: bold;width: 56%;">
      </my-article>
    </div>
    <div class="link" style="height: 150px;">
      <my-link></my-link>
    </div>
    <div class="footer" style="height: 100px;">
      <my-footer></my-footer>
    </div>
  </div>
</template>

<script>
import header from "../../components/header/header.vue"
import navbar from "../../components/navbar/navbar.vue"
import swiper from "../../components/swiper/swiper.vue"
import link from "../../components/link/link.vue"
import foorter from "../../components/footer/footer.vue"
import article from "../../components/article/article.vue"
import hostnew from "../../components/schoolnew/hostnew.vue"
export default {
  components:{
    "my-header":header,
    "my-navbar":navbar,
    "my-swiper":swiper,
    'my-footer':foorter,
    "my-link":link,
    "my-article":article,
    "my-hostnew":hostnew
  },
  data () {
    return {
    }
  }
}
</script>

<style  scoped>
.hostnew{
  display: flex;
  justify-content: center;
}
.article{
  display: flex;
  justify-content: center;
}
.link{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/schoolnew/schoolnew.vue